import { AuthConfig, OAuthModuleConfig } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";

export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: environment.sts,
  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + "/auth/sso-callback",
  //redirectUri: window.location.origin + "/dossiers",
  // The SPA's id. The SPA is registerd with this id at the auth-server
  // clientId: 'server.code',
  clientId: environment.clientId,
  // Just needed if your auth server demands a secret. In general, this
  // is a sign that the auth server is not configured with SPAs in mind
  // and it might not enforce further best practices vital for security
  // such applications.
  // dummyClientSecret: 'secret',
  responseType: "code",
  // set the scope for the permissions the client should request
  // The first four are defined by OIDC.
  // Important: Request offline_access to get a refresh token
  scope: "api://${auth-client-id}/nx-user",
  showDebugInformation: !environment.production || environment.test,
  strictDiscoveryDocumentValidation: false,
  postLogoutRedirectUri: window.location.origin + "/",
  redirectUriAsPostLogoutRedirectUriFallback: true
};

export const oauthModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [environment.api, environment.data],
    sendAccessToken: true,
  },
};
